import { useState, type MouseEvent } from 'react';
import type { Meta, StoryFn } from '@storybook/react';

import { Button, useElement } from '@pega/cosmos-react-core';
import { ItemLibrary, type LibraryItem } from '@pega/cosmos-react-build';

import { nodeLibrary } from './LibraryPicker.mocks';

export default {
  title: 'Build/LibraryPicker',
  component: ItemLibrary,
  parameters: {
    docs: {
      description: {
        component:
          'Library picker is a picker component enhanced with search and grouping of case tasks.'
      }
    },
    controls: {
      disable: true
    }
  }
} as Meta;

export const ItemPicker: StoryFn = () => {
  const [selectedItem, setSelectedItem] = useState<LibraryItem>();
  const [target, setTarget] = useElement<HTMLButtonElement>(null);

  const btnClick = (e: MouseEvent<HTMLButtonElement>) => setTarget(e.currentTarget);

  const onSelect = (item: LibraryItem) => {
    setSelectedItem(item);
  };

  return (
    <>
      {selectedItem ? <div>Selected: {selectedItem.primary}</div> : ''}
      <Button onClick={btnClick}>Select from library</Button>
      {target && (
        <ItemLibrary
          items={nodeLibrary}
          target={target}
          onClick={onSelect}
          onDismiss={() => setTarget(null)}
        />
      )}
    </>
  );
};
